import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.usb-add', {
        url: '/add-usb-tokens',
        views: {
            '@company': 'addUsbTokens'
        }
    })
}





// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/usb-token-add/usb-add.state.js